import { call, all, takeEvery, put, fork } from 'redux-saga/effects';
import { notification } from '@isomorphic/shared/isomorphic/components';
import actions from './actions';
import SuperFetch from '../../helpers/superFetch';
// import jsonSearch from './jsonsearch.json';

export function* locationFields() {
  yield takeEvery(actions.LOCATION_FIELDS, function*() {
    console.log('GET location/fields (no queryString)');
    const response = yield call(SuperFetch.get, 'location/fields');
    // let response = jsonFields;
    console.log('RESPONSE location/fields:');
    console.log(JSON.stringify(response));
    if (response.Status !== 'error' && !response.error) {
      let fields = response.Data.Fields;
      yield put({
        type: actions.LOCATION_FIELDS_SUCCESS,
        fields: fields,
      });
    } else {
      yield put({
        type: actions.LOCATION_ERROR,
        logError: Math.floor(Date.now() / 1000),
      });
      yield notification('error', response.Message, '', true); //allow silent if server error
    }
  });
}

export function* locations() {
  yield takeEvery(actions.LOCATIONS, function*({ queryString }) {
    console.log('GET locations queryString:');
    console.log(JSON.stringify(queryString));
    const response = yield call(SuperFetch.get, 'location?' + queryString);
    console.log('RESPONSE locations:');
    console.log(JSON.stringify(response));
    if (response.Status !== 'error' && !response.error) {
      let locations = response.Data.Locations;
      yield put({
        type: actions.LOCATION_SUCCESS,
        locations: locations,
      });
    } else {
      yield put({
        type: actions.LOCATION_ERROR,
        locationError: Math.floor(Date.now() / 1000),
      });
      yield notification('error', response.Message, '', true); //allow silent if server error
    }
  });
}

export function* locationCreate() {
  yield takeEvery(actions.LOCATION_CREATE, function*({ createdLocation }) {
    let locations = [];
    locations.push(createdLocation);
    const data = { Data: { Locations: locations } };
    console.log(JSON.stringify(data));
    const response = yield call(SuperFetch.post, 'location/create', data);
    console.log('RESPONSE location/create:');
    console.log(JSON.stringify(response));
    if (response.Status !== 'error' && !response.error) {
      let locationCreateSuccess = response.Data.Locations[0];
      yield put({
        type: actions.LOCATION_CREATE_SUCCESS,
        locationCreateSuccess: locationCreateSuccess,
      });
    } else {
      yield put({
        type: actions.LOCATION_ERROR,
        locationError: Math.floor(Date.now() / 1000),
      });
      yield notification('error', response.Message);
    }
  });
}

export function* locationUpdate() {
  yield takeEvery(actions.LOCATION_UPDATE, function*({ updatedLocation }) {
    let locations = [];
    locations.push(updatedLocation);
    const data = { Data: { Locations: locations } };
    console.log('POST location/update json:');
    console.log(JSON.stringify(data));
    const response = yield call(SuperFetch.post, 'location/update', data);
    console.log('RESPONSE location/update:');
    console.log(JSON.stringify(response));
    if (response.Status !== 'error' && !response.error) {
      let locationUpdateSuccess = response.Data.Locations[0];
      yield put({
        type: actions.LOCATION_UPDATE_SUCCESS,
        locationUpdateSuccess: locationUpdateSuccess,
      });
    } else {
      yield put({
        type: actions.LOCATION_ERROR,
        locationError: Math.floor(Date.now() / 1000),
      });
      yield notification('error', response.Message);
    }
  });
}

export function* locationDelete() {
  yield takeEvery(actions.LOCATION_DELETE, function*({ deletedLocation }) {
    var queryString = 'ID=' + deletedLocation.ID;
    console.log('POST location/delete queryString:');
    console.log(JSON.stringify(queryString));
    const response = yield call(
      SuperFetch.delete,
      'location/delete?' + queryString
    );

    if (response.Status !== 'error' && !response.error) {
      let locationDeleteSuccess = deletedLocation;
      yield put({
        type: actions.LOCATION_DELETE_SUCCESS,
        locationDeleteSuccess: locationDeleteSuccess,
      });
    } else {
      yield put({
        type: actions.LOCATION_ERROR,
        locationError: Math.floor(Date.now() / 1000),
      });
      yield notification('error', response.Message);
    }
  });
}

/*
Saga loader
*/
export default function* rootSaga() {
  yield all([
    fork(locationFields),
    fork(locations),
    fork(locationCreate),
    fork(locationUpdate),
    fork(locationDelete),
  ]);
}
